import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import type { AccountManager as AccountManagerType } from '@/lib/types/bevmaq.types';

export function AccountManager({
  containerClasses,
  profileImage,
  name,
  phone,
  email,
  companyPosition,
  imgClass,
  accountManager,
}: {
  containerClasses?: string;
  profileImage?: string;
  name?: string;
  phone?: string;
  email?: string;
  companyPosition?: string;
  imgClass?: string;
  accountManager: AccountManagerType;
}) {
  const { t } = useTranslation();
  return (
    <div
      className={`w-full space-y-4 p-8 text-center ${
        containerClasses ? containerClasses : 'bg-gray2-100'
      } `}
    >
      <div
        className={
          `relative mx-auto h-[16em] w-[16em] overflow-hidden rounded-3xl border-8 border-orange-400 ` +
          imgClass
        }
      >
        <Image
          src={profileImage ?? accountManager.profile_picture}
          alt='Contact image'
          fill
          className='object-cover'
        />
      </div>
      <div className=''>
        <h3>{companyPosition ?? t('common:Your Account Manager')}</h3>
        <h3 className='font-semibold'>{name ?? accountManager.name}</h3>
      </div>
      <div className=''>
        <h3>
          {t('common:Phone')}:{' '}
          <a href={phone ?? '+49 173 90 80 414'} className='link'>
            {phone ?? accountManager.phone}
          </a>
        </h3>
        <h3>
          {t('common:email')}:{' '}
          <a href={email ?? 'c.hormes@bevmaq.com'} className='link'>
            {email ?? accountManager.email}
          </a>
        </h3>
      </div>
    </div>
  );
}
